export const PAGE_STATES = {
  INDEX: 'index',
  SELECTED_CATEGORIES: 'selectedCategories',
  SEARCH: 'search',
};
